/* eslint-disable import/prefer-default-export */
export function limitPositionText(event, value) {
  const newLines = value.split('\n').length;
  if (event.keyCode === 13 && newLines >= 3) {
    return false;
  }
  return true;
}
